import { v4 as uuidv4 } from "uuid";

export const mapMovementDataToVolumeForm = (
  movementsEquipments = [],
  movementsProducts = [],
  movementsVolumes = [],
) => {
  const bipeds = {};

  // 1. Bipeds de equipamentos (chave: movement_item.id)
  movementsEquipments.forEach((eq) => {
    const identify = `eq_${eq.id}`;
    bipeds[identify] = {
      identify,
      equipment: {
        id: eq.equipment_id,
        movement_item_id: eq.id, // ID do movement_item
        number: eq.equipment_number,
        name: eq.equipment_name,
      },
    };
  });

  // 2. Bipeds de produtos (chave: movement_item.id)
  movementsProducts.forEach((prod) => {
    const identify = `prod_${prod.id}`;
    bipeds[identify] = {
      identify,
      product: {
        name: prod.product_name || prod.product,
        code: prod.product_code || "",
      },
      service_order_item: {
        product: {
          items: [
            {
              id: prod.product_item_id || prod.id,
              category: { name: prod.category_name || "" },
              condition: { name: prod.condition_name || "" },
            },
          ],
        },
        fulfilled_quantity_product: prod.quantity_product || 0,
      },
    };
  });

  // 3. Mapeia volumes existentes
  const initialVolumes = movementsVolumes.map((vol) => ({
    identifier: vol.id || uuidv4(),
    id: vol.id,
    name: vol.name,
    hasShipment: vol.hasShipment || false,
    shipmentId: vol.shipmentId || null,
    items: (vol.items || []).map((item) => {
      const isEquipment = item.type === "equipment";

      // O identify do volume_item DEVE bater com a chave do biped
      // O movement_item_id é a ponte entre os dois
      const identify = isEquipment
        ? `eq_${item.movement_item_id}`
        : `prod_${item.movement_item_id}`;

      if (isEquipment) {
        return {
          type: "equipment",
          identify,
          equipment_id: item.equipment_id,
          equipment_number: item.equipment_number,
          equipment_name: item.equipment_name,
        };
      }

      return {
        type: "product",
        identify,
        product_item_id: item.product_item_id,
        product_id: item.product_id,
        product_code: item.product_code || "",
        product_name: item.product_name || "",
        product_category: item.product_category || "",
        product_condition: item.product_condition || "",
        quantity: item.quantity || 1,
      };
    }),
  }));

  return { bipeds, initialVolumes };
};
